import api from "./axiosClient";

export const getSalesReport = async (params) => {
    const res = await api.get("/sales/sales-report", {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            restaurantId: params.restaurantId
        }
    });
    return res.data;
};

export const getAdminAnalytics = async (params) => {
    const res = await api.get("/sales/analytics/dashboard", {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            restaurantId: params.restaurantId,
            productCategory: params.productCategory,
        },
        signal: params.signal,
    });
    return res.data;
};

export const downloadSalesReport = async (params) => {
    const res = await api.get("/sales/sales-report/download", {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            restaurantId: params.restaurantId,
        },
        responseType: "blob",
    });
    return res;
};

export const downloadSettledBills = async (params) => {
    const res = await api.get("/sales/sales-report/settled-bills/download", {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            restaurantId: params.restaurantId,
        },
        responseType: "blob",
    });
    return res;
};